import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { S1InvestStrategiesTable } from "./table";
import { S1InvestStrategiesCard } from "./card";
import { S1InvestStrategiesNew } from "./new";

export default function S1InvestStrategies() {
  useEffect(() => {
    setDocumentTitle("Quantilia | S1 Invest Strategies");
  }, []);

  return (
    <Routes>
      <Route index element={<S1InvestStrategiesTable />} />
      <Route path="/new" element={<S1InvestStrategiesNew />} />
      <Route path=":id" element={<S1InvestStrategiesCard />} />
    </Routes>
  );
}
